export default __webpack_public_path__ + "static/media/Val-Bg.93507b7c.jpg";